type FacetDistribution = Record<string, Record<string, number>>

export function getRefiningTags(distribution: FacetDistribution | undefined, limit: number): string[] {
  // Every asset has one vertical, so these counts partition the same result set as the tag counts.
  const total = Object.values(distribution?.vertical ?? {}).reduce((sum, count) => sum + count, 0)
  return Object.entries(distribution?.tags ?? {})
    .filter(([, count]) => count > 0 && (total === 0 || count !== total))
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, limit)
    .map(([tag]) => tag)
}
